module.exports = __webpack_public_path__ + "img/no-records-my-team-actiivity.e7ba15e0.webp";